export const STEP_META = {
  1: {
    title: 'Select Subject',
    para: (
      <>
        <p>
          Choose the subject for which you want to create the exam paper. This
          helps us tailor the topics and questions specifically to your
          selection.
        </p>
      </>
    ),
  },
  2: {
    title: 'Select Topic',
    para: (
      <>
        <p>
          Pick the topics you want to include in the exam. You can choose
          multiple topics to create a comprehensive paper.
        </p>
      </>
    ),
  },
  3: {
    title: 'Set Questions, Complexity & Marks',
    para: (
      <>
        <p>
          Decide how many questions to include from each topic and specify their
          complexity levels. This helps create a balanced and tailored exam
          paper.
        </p>
      </>
    ),
  },
};
